const AuthHeading = ({ title }) => {
  return <h4 className="text-xl font-semibold text-center">{title}</h4>;
};

export default AuthHeading;
